import React, { useEffect, useState } from "react";
import axios from "axios";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import serverConfig from "../config";
import "./Home.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment";
import "./Conferences.css";
import SecondaryMenu from "../SecondaryMenu";

import toast, { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
import { FileJsonIcon } from "lucide-react";

moment.locale("it"); // Imposta la localizzazione su italiano

function Conferences() {
  //const [selectedYear, setSelectedYear] = useState(new Date());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  const [content, setContent] = useState(null);

  /*
  const handleYearChange = (date) => {
    setSelectedYear(date);
  };
  */

  const handleYearChange = (date) => {
    setSelectedYear(date.getFullYear());
  };

  useEffect(() => {
    axios
      .post(`${serverConfig.serverUrl}/get_conferences_year`, {
        year: selectedYear,
      })
      .then((response) => {
        const data = response.data;
        setContent(data);
      })
      .catch((error) => {
        //alert("ERRORE | get_conferences_year");
        //console.log("PAGINA INIZIALE | get_conferences_year | error", error);
        toast.error("La risorsa non è al momento disponibile");
      });
  }, [selectedYear]);

  /*
  const renderConferenceItems = (items) => {
    // Divide gli elementi in coppie per visualizzarli in due colonne per riga
    const pairs = [];
    for (let i = 0; i < items.length; i += 2) {
      pairs.push(items.slice(i, i + 2));
    }

    return (
      <div className="conference-items">
        {pairs.map((pair, pairIndex) => (
          <div className="row" key={pairIndex}>
            {pair.map((item, itemIndex) => (
              <div className="col-12 col-lg-6" key={itemIndex}>
                <a
                  href={item.link}
                  className="conference-item-link"
                  target={"_blank"}
                     rel="noreferrer"
                >
                  <div
                    className="conference-item"
                    style={{ overflowX: "auto", overflowY: "auto" }}
                  >
                    <div className="conference-item-title">
                      {item.title && (
                        <div>
                          <h1>{item.title}</h1>
                        </div>
                      )}
                    </div>
                    <div className="conference-item-content-details">
                      <img
                        src={`${serverConfig.serverUrl}/img/conference/${item.img}`}
                        alt={item.img}
                        className="conference-img"
                      />
                      <div className="conference-item-content">
                        {item.start_date && (
                          <div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-calendar2-check"
                              viewBox="0 0 16 16"
                              style={{ marginRight: "10px", color: "green" }}
                            >
                              <path d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0" />
                              <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                              <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z" />
                            </svg>
                            START: <span>{item.start_date}</span>
                          </div>
                        )}
                        {item.end_date && (
                          <div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-calendar2-x"
                              viewBox="0 0 16 16"
                              style={{ marginRight: "10px", color: "red" }}
                            >
                              <path d="M6.146 8.146a.5.5 0 0 1 .708 0L8 9.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 10l1.147 1.146a.5.5 0 0 1-.708.708L8 10.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 10 6.146 8.854a.5.5 0 0 1 0-.708" />
                              <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                              <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z" />
                            </svg>
                            END: <span>{item.end_date}</span>
                          </div>
                        )}
                        {item.text && (
                          <div>
                            <span>{item.text}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };
  */

  const circleImg = (img, title) => {
    const src = `${serverConfig.serverUrl}/img/conference/${img}`; // Percorso dell'immagine
    const handleImageError = (event) => {
      event.target.src = ""; // Imposta l'immagine di fallback su una stringa vuota per evitare il loop di ricaricamento
      event.target.style.backgroundColor = "white"; // Imposta lo sfondo bianco
    };
    return (
      <>
        <div /*</>className="circle-chat-list"*/>
          <img
            src={src}
            alt={`${title}`}
            style={{
              width: "100%",
              height: "200px",
              objectFit: "contain",
              backgroundColor: "transparent", // Imposta lo sfondo trasparente per mostrare il bianco dietro in caso di errore
              borderRadius: "5%",
            }}
            onError={handleImageError} // Ascolta l'evento onError per gestire l'errore di caricamento dell'immagine
            draggable={false}
          />
        </div>
      </>
    );
  };

  const renderConferenceItems = (items) => {
    // Divide gli elementi in coppie per visualizzarli in due colonne per riga
    const pairs = [];
    for (let i = 0; i < items.length; i += 2) {
      pairs.push(items.slice(i, i + 2));
    }
    const resolveLink = (link) => {
      switch (true) {
        case link.startsWith("http"):
          return link;
        default:
          return "/conference";
      }
    };

    return (
      <div className="conference-items">
        {pairs.map((pair, pairIndex) => (
          <div className="row" key={pairIndex}>
            {pair.map((item, itemIndex) => (
              <div className="col-12 col-lg-6" key={itemIndex}>
                {item.link !== "" ? (
                  <>
                    <a
                      className="conference-item-link"
                      href={
                        item.link.startsWith("conference")
                          ? item.link
                          : item.link
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        textDecoration: "none",
                        color: "inherit",
                        cursor: "pointer",
                      }}
                    >
                      <div
                        className="conference-item"
                        style={{ overflowX: "auto", overflowY: "auto" }}
                      >
                        <div className="conference-item-title">
                          {item.title && (
                            <div>
                              <h1>{item.title}</h1>
                            </div>
                          )}
                        </div>
                        <div className="conference-item-content-details">
                          {/*
                          <img
                            src={`${serverConfig.serverUrl}/img/conference/${item.img}`}
                            alt={item.img}
                            className="conference-img"
                          />
                          */}

                          <div className="conference-img-large">
                            <div>{circleImg(item.img, item.title)}</div>
                          </div>
                          <div className="conference-item-content">
                            {/*}
                            {item.start_date && (
                              <div>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-calendar2-check"
                                  viewBox="0 0 16 16"
                                  style={{
                                    marginRight: "10px",
                                    color: "green",
                                  }}
                                >
                                  <path d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0" />
                                  <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                                  <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z" />
                                </svg>
                                START: <span>{item.start_date}</span>
                              </div>
                            )}
                            {item.end_date && (
                              <div>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-calendar2-x"
                                  viewBox="0 0 16 16"
                                  style={{ marginRight: "10px", color: "red" }}
                                >
                                  <path d="M6.146 8.146a.5.5 0 0 1 .708 0L8 9.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 10l1.147 1.146a.5.5 0 0 1-.708.708L8 10.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 10 6.146 8.854a.5.5 0 0 1 0-.708" />
                                  <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                                  <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z" />
                                </svg>
                                END: <span>{item.end_date}</span>
                              </div>
                            )}
                            */}

                            <div className="conference-dates">
                              {item.start_date && (
                                <div style={{textAlign: "center"}}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-calendar2-check"
                                    viewBox="0 0 16 16"
                                    style={{
                                      marginRight: "10px",
                                      color: "green",
                                    }}
                                  >
                                    <path d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0" />
                                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                                    <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z" />
                                  </svg>
                                  <strong>START</strong>:{" "}<br></br>
                                  <span>{item.start_date}</span>
                                </div>
                              )}
                              {item.end_date && (
                                <div style={{textAlign: "center"}}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-calendar2-x"
                                    viewBox="0 0 16 16"
                                    style={{
                                      marginRight: "10px",
                                      color: "red",
                                    }}
                                  >
                                    <path d="M6.146 8.146a.5.5 0 0 1 .708 0L8 9.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 10l1.147 1.146a.5.5 0 0 1-.708.708L8 10.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 10 6.146 8.854a.5.5 0 0 1 0-.708" />
                                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                                    <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z" />
                                  </svg>
                                  <strong>END</strong>:{" "}<br></br>
                                  <span>{item.end_date}</span>
                                </div>
                              )}
                            </div>

                            {item.text && (
                              <div>
                                <span>{item.text}</span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </a>
                  </>
                ) : (
                  <div
                    className="conference-item"
                    style={{ overflowX: "auto", overflowY: "auto" }}
                  >
                    <div className="conference-item-title">
                      {item.title && (
                        <div>
                          <h1>{item.title}</h1>
                        </div>
                      )}
                    </div>
                    <div className="conference-item-content-details">
                      {/*
                          <img
                            src={`${serverConfig.serverUrl}/img/conference/${item.img}`}
                            alt={item.img}
                            className="conference-img"
                          />
                          */}

                      <div className="conference-img-large">
                        <div>{circleImg(item.img, item.title)}</div>
                      </div>
                      <div className="conference-item-content">
                        {/*}
                        {item.start_date && (
                          <div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-calendar2-check"
                              viewBox="0 0 16 16"
                              style={{ marginRight: "10px", color: "green" }}
                            >
                              <path d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0" />
                              <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                              <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z" />
                            </svg>
                            START: <span>{item.start_date}</span>
                          </div>
                        )}
                        {item.end_date && (
                          <div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-calendar2-x"
                              viewBox="0 0 16 16"
                              style={{ marginRight: "10px", color: "red" }}
                            >
                              <path d="M6.146 8.146a.5.5 0 0 1 .708 0L8 9.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 10l1.147 1.146a.5.5 0 0 1-.708.708L8 10.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 10 6.146 8.854a.5.5 0 0 1 0-.708" />
                              <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                              <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z" />
                            </svg>
                            END: <span>{item.end_date}</span>
                          </div>
                        )}
                        */}

                        <div className="conference-dates">
                          {item.start_date && (
                            <div>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-calendar2-check"
                                viewBox="0 0 16 16"
                                style={{
                                  marginRight: "10px",
                                  color: "green",
                                }}
                              >
                                <path d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0" />
                                <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                                <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z" />
                              </svg>
                              <strong>START</strong>:{" "}
                              <span>{item.start_date}</span>
                            </div>
                          )}
                          {item.end_date && (
                            <div>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-calendar2-x"
                                viewBox="0 0 16 16"
                                style={{
                                  marginRight: "10px",
                                  color: "red",
                                }}
                              >
                                <path d="M6.146 8.146a.5.5 0 0 1 .708 0L8 9.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 10l1.147 1.146a.5.5 0 0 1-.708.708L8 10.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 10 6.146 8.854a.5.5 0 0 1 0-.708" />
                                <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                                <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z" />
                              </svg>
                              <strong>END</strong>: <span>{item.end_date}</span>
                            </div>
                          )}
                        </div>

                        {item.text && (
                          <div>
                            <span>{item.text}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };

  const viewConferences = (
    <>
      <div
        style={{
          border: "2px solid #D8DEE9",
          backgroundColor: "#F5F7FA",
          color: "#2C2C2C",
          borderRadius: "10px",
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
          //boxShadow: "0 0 10px rgba(245, 247, 250, 0.5)",
          margin: "10px",
          padding: "10px",
          textAlign: "center",
          fontSize: "25px",
        }}
      >
        <label style={{ marginRight: "10px" }}>
          <strong>CONGRESSI E WORKSHOP PER L'ANNO </strong>
        </label>
        {/*
        <DatePicker
          selected={selectedYear}
          onChange={handleYearChange}
          dateFormat="yyyy"
          showYearPicker
          placeholderText="Seleziona l'anno"
          className="custom-datapicker"
        />
        */}
        <DatePicker
          selected={new Date(selectedYear, 0, 1)} // Primo gennaio dell'anno selezionato
          onChange={handleYearChange}
          dateFormat="yyyy"
          showYearPicker
          placeholderText="Seleziona l'anno"
          className="custom-datapicker"
        />
      </div>
      {content && (
        <div>
          {Object.entries(content)
          .sort((a,b) => a.order - b.order)
          .map(([group, items]) => (
            <div key={group}>{renderConferenceItems(items)}</div>
          ))}
        </div>
      )}
    </>
  );

  const [showSidebar, setShowSidebar] = useState(window.innerWidth > 992);

  const handleResize = () => {
    if (window.innerWidth > 992) {
      setShowSidebar(true);
    } else {
      setShowSidebar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div>
      {/*}
      <div className="row">
        <div className="col-12 col-lg-2">
          <SecondaryMenu vertical={true}></SecondaryMenu>
        </div>
        <div className="col-12 col-lg-10">{viewConferences}</div>
      </div>
      */}

      <div
        className={`row home-container ${
          showSidebar ? "show-sidebar" : "hide-sidebar"
        }`}
      >
        <Toaster />
        <button
          className="show-sidebar-button"
          onClick={() => setShowSidebar(!showSidebar)}
        >
          {showSidebar ? "Nascondi Menu" : "Mostra Menu"}
        </button>

        {window.innerWidth <= 992 ? (
          showSidebar ? (
            <div className="col-12">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
          ) : (
            <div className={`main-content col-12`}>{viewConferences}</div>
          )
        ) : (
          <>
            <div className="col-2 sidebar-left">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
            <div
              className={`main-content ${showSidebar ? "col-10" : "col-12"}`}
            >
              {viewConferences}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Conferences;
